import { ProFormaModelIds } from 'constants/proForma';

export const isApartmentModel = (proFormaModelId: ProFormaModelIds): boolean => (
    proFormaModelId === ProFormaModelIds.APARTMENT
);
export const isApartmentWithRetailModel = (proFormaModelId: ProFormaModelIds): boolean => proFormaModelId === ProFormaModelIds.APARTMENT_WITH_RETAIL;
export const isAllApartmentModels = (proFormaModelId: ProFormaModelIds): boolean => (
    [ProFormaModelIds.APARTMENT, ProFormaModelIds.APARTMENT_WITH_RETAIL].includes(proFormaModelId)
);
export const isStudentHousingModel = (proFormaModelId: ProFormaModelIds): boolean => proFormaModelId === ProFormaModelIds.STUDENT_HOUSING;
export const isLandDevelopmentModel = (proFormaModelId: ProFormaModelIds): boolean => proFormaModelId === ProFormaModelIds.LAND_DEVELOPMENT

// Model features

export enum ProFormaFeature {
    RECOVERABLE_EXPENSES = 'RECOVERABLE_EXPENSES',
    LEASING_COST_RESERVES = 'LEASING_COST_RESERVES',                             
}

const MODEL_FEATURE_SUPPORT: Record<ProFormaFeature, ProFormaModelIds[]> = {            
    [ProFormaFeature.LEASING_COST_RESERVES]: [                                   
        ProFormaModelIds.INDUSTRIAL,                                             
        ProFormaModelIds.RETAIL,
        ProFormaModelIds.OFFICE,                                                 
        ProFormaModelIds.APARTMENT_WITH_RETAIL,                                
    ],                                                                           
    [ProFormaFeature.RECOVERABLE_EXPENSES]: [                                  
        ProFormaModelIds.RETAIL,                                                 
        ProFormaModelIds.OFFICE,
        ProFormaModelIds.INDUSTRIAL,                                             
        ProFormaModelIds.APARTMENT_WITH_RETAIL,                                  
        ProFormaModelIds.DATA_CENTER,
    ],                                                                           
};

export const hasModelFeature = (
    proFormaModelId: ProFormaModelIds,
    feature: ProFormaFeature,
): boolean => (
    MODEL_FEATURE_SUPPORT[feature].includes(proFormaModelId)                            
);  

export const isModelWithLeasingCostReserves = (id: ProFormaModelIds) =>
    hasModelFeature(id, ProFormaFeature.LEASING_COST_RESERVES);

